/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolExtensionIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-extension"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M4.58 21.8Q3.58 21.8 2.89 21.11Q2.2 20.43 2.2 19.45L2.2 16.32Q2.2 15.95 2.46 15.66Q2.73 15.38 3.1 15.3Q4.08 15.05 4.72 14.32Q5.38 13.6 5.38 12.6Q5.38 11.6 4.7 10.88Q4.03 10.15 3.08 9.88Q2.7 9.78 2.45 9.51Q2.2 9.25 2.2 8.88L2.2 5.58Q2.2 4.58 2.89 3.89Q3.58 3.2 4.55 3.2L7.58 3.2Q7.85 1.88 8.94 0.95Q10.03 0.03 11.45 0.03Q12.93 0.03 14.03 0.95Q15.13 1.88 15.32 3.2L18.43 3.2Q19.4 3.2 20.1 3.89Q20.8 4.58 20.8 5.58L20.8 9.1Q21.85 9.6 22.38 10.54Q22.9 11.47 22.9 12.6Q22.9 13.7 22.38 14.65Q21.85 15.6 20.8 16.07L20.8 19.45Q20.8 20.43 20.1 21.11Q19.4 21.8 18.43 21.8Z" fill={color} />
    </svg>
  );
}
